export const globalStyles = {
  cell: {
    display: 'block',
    float: 'left',
    letterSpacing: '0.0875em',
    fontWeight: '300',
    textTransform: 'uppercase'
  }
};



// WEBPACK FOOTER //
// ./styles/globalStyles.js